<template>
  <section class="ut-p-6 prospect-stage-question">
    <h3 class="question-title">When do you want to follow-up?</h3>
      <div class="form-group">
        <textarea v-model="followUpNote"
          v-gaEvent="{ category: gacategory,
                      action: 'Prospect Profile - follow up leave a note'}"
          placeholder="Add a note..." class="ut-h-16">
        </textarea>
        <oa-datepicker id="follow-up-date"
                       class="ut-w-64 ut-ml-0 ut-max-w-full"
                       v-model="followUpDate"
                       :disabledDates="disabledDates"
                       v-gaEvent="{ category: gacategory,
                              action: 'Prospect Profile - follow up pick date'}" />
        <span class="error ut-text-sm ut-font-bold"
              v-show="validationError">
              Please select a date</span>
      </div>
    <button @click="confirm()"
            class="btn btn-green-inverted confirm-btn"
            :class="{ 'disabled': disabledButtonClick }">Save</button>
  </section>
</template>

<script>
import { mapActions } from 'vuex';
import moment from 'moment';
import OaDatepicker from '@/components/Forms/OaDatepicker.vue';
import { ProspectReminderTypeId } from '@/Mapper/ProspectActivityActionType';


export default {
  name: 'ProspectStageQuesSetFollowUpReminder',
  components: {
    OaDatepicker,
  },
  props: {
    prospect: {
      type: Object,
      required: true,
    },
    userid: {
      required: true,
    },
  },
  data() {
    return {
      gacategory: 'Prospecting Tool Agent portal',
      disabledDates: {
        to: moment().subtract(1, 'days').toDate(),
      },
      followUpDate: '',
      followUpNote: '',
      validationError: false,
      disabledButtonClick: false,
    };
  },
  computed: {

  },
  created() {

  },
  methods: {
    ...mapActions('prospectStore', [
      'createReminder',
    ]),
    confirm() {
      if (this.disabledButtonClick) {
        return false;
      }

      if (!this.followUpDate) {
        this.validationError = true;
        return false;
      }

      this.disabledButtonClick = true;

      // create reminder
      const payload = {
        prospectKey: this.prospect.key,
        reminderTypeId: ProspectReminderTypeId.followUp,
        creatorUserId: this.userid,
        description: this.followUpNote !== '' ? this.followUpNote : null,
        reminderDate: this.$helpers.convertToUTC(this.followUpDate, 'YYYY-MM-DD HH:mm:ss'),
      };

      this.createReminder(payload).then(() => {
        this.$emit('update-view', 'didYouFollowUp');
      }).catch((error) => {
        this.disabledButtonClick = false;
        console.log(error);
      });

      return true;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  @import "@/assets/styles/prospect-stage-questions";
</style>
